import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { motion } from "framer-motion";
import { fadeUp, viewport } from "../../lib/motion";

export default function ServiceCard({ service, index }) {
  return (
    <motion.div
      variants={fadeUp}
      initial="hidden"
      whileInView="show"
      viewport={viewport}
      className="group"
    >
      <Link
        // `route` comes from the CMS; the bundled fallback supplies it too.
        to={service.route || `/${service.slug}`}
        data-testid={`service-card-${service.slug}`}
        className="block relative overflow-hidden border border-charcoal hover:border-emerald/60 transition-colors bg-charcoal/10"
      >
        <div className="relative aspect-[4/5] overflow-hidden">
          <img
            // `heroImage` is the CMS field; `hero` was the bundled one.
            src={service.heroImage || service.hero}
            alt={service.heroImageAlt || `Emilio's Solutions ${service.name} in Singapore`}
            loading="lazy"
            className="absolute inset-0 h-full w-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-[1.06]"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/10 to-transparent" />
          <div className="absolute top-4 left-4 text-emerald text-xs font-mono">
            {String((index ?? 0) + 1).padStart(2, "0")}
          </div>
          <div className="absolute top-4 right-4 w-9 h-9 rounded-full bg-emerald/0 border border-emerald/40 grid place-items-center opacity-0 group-hover:opacity-100 group-hover:bg-emerald transition-all duration-300">
            <ArrowUpRight className="w-4 h-4 text-emerald group-hover:text-ink" />
          </div>
        </div>
        <div className="p-5 md:p-6 border-t border-charcoal/60">
          {/*
            The CMS carries a single `group`; the old bundled shape had a
            `category` array. Reading `category[0]` unguarded crashed the whole
            page when the field was absent, so this falls back and tolerates
            either shape.
          */}
          {(service.group || service.category?.[0]) && (
            <div className="text-eyebrow font-display font-bold uppercase tracking-[0.22em] text-emerald mb-2">
              {service.group || service.category[0]}
            </div>
          )}
          <h3 className="font-display text-xl md:text-2xl font-bold text-white leading-tight">
            {service.name}
          </h3>
          <p className="mt-3 text-sm text-mutedtext leading-relaxed line-clamp-2">
            {service.shortDescription}
          </p>
          <div className="mt-5 flex items-center gap-2 text-emerald text-sm font-semibold">
            Learn More
            <ArrowUpRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </div>
        </div>
      </Link>
    </motion.div>
  );
}
